/* eslint-disable @reatom/unit-naming-rule */
import { useAction } from '@reatom/npm-react'
import { useEffect } from 'react'
import styled from 'styled-components'

import { reatomFavoritePairsTable } from '@root/features/favorite-pairs/atoms/reatom-favorite-pairs-table'
import { FavoritePairsList } from '@root/features/favorite-pairs/ui/mobile'
import { FavoritePairsSorting } from '@root/features/favorite-pairs/ui/mobile/favorite-pairs-sorting'
import { useAppRoutes } from '@root/features/routing'

type WatchlistPageProps = {}

const model = reatomFavoritePairsTable()

export const WatchlistPage: React.FC<WatchlistPageProps> = () => {
  const { navigateToTrading } = useAppRoutes()
  const refresh = useAction(model.refresh)

  useEffect(() => {
    refresh()
  }, [refresh])

  return (
    <Root>
      <FavoritePairsSorting model={model} />
      <FavoritePairsList
        model={model}
        onPairClick={(pair) => {
          navigateToTrading(pair.address, pair.network)
        }}
      />
    </Root>
  )
}

const Root = styled.div`
  --data-table-header-padding-inline: 12px;
  background: var(--background-1);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
